export default "__VITE_ASSET__UX$vXzd7__"